import { GridCellProps } from '@progress/kendo-react-grid';
import { format } from 'date-fns';
import GridCellBase from 'src/components/GridCellBase';

const StatusDateCell = (props: GridCellProps) => {
  const field = props.field || '';
  const value = props.dataItem[field];
  const formattedValue = value ? format(new Date(value), props.format) : '';

  return (
    <GridCellBase {...props} title={formattedValue} rowSelectionEnabled={false}>
      {formattedValue}
    </GridCellBase>
  );
};

export default StatusDateCell;
